import classNames from "classnames";
import { useFormik } from "formik";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import { toastMessage } from "shared/components/common/toast";
import { ChangePasswordService } from "shared/services/user";
import { UpdatePasswordVS } from "shared/utils/validation";
import styles from "../style.module.scss";
import { Icons } from "assets";

const initialValues: UpdatePasswordType = {
  oldPassword: "",
  confirmPassword: "",
  password: "",
};

const Account = () => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: UpdatePasswordVS,
    onSubmit: () => {
      handleUpdatePassword();
    },
  });

  const {
    handleChange,
    handleSubmit,
    values,
    touched,
    errors,
    isSubmitting,
    setSubmitting,
    resetForm,
  } = formik;

  const handleUpdatePassword = () => {
    setSubmitting(true);
    ChangePasswordService(values)
      .then(({ status }) => {
        if (status) {
          toastMessage("success", "Password Updated Successfully");
          resetForm();
        }
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <div className={classNames("flex flex-col w-full", styles.mainContainer)}>
      <h3>Change Password</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <CustomInput
          label="Current Password"
          placeholder="***************"
          required
          isPassword
          type="password"
          Icon={Icons.Lock}
          value={values.oldPassword}
          error={
            touched.oldPassword && errors.oldPassword ? errors.oldPassword : ""
          }
          onChange={handleChange("oldPassword")}
          customLabelStyle={classNames(styles.labelStyle)}
          customInputStyle={classNames(styles.inputStyle)}
        />
        <div className={classNames("flex flex-col sm:flex-row gap-4")}>
          <CustomInput
            label="New Password"
            placeholder="***************"
            required
            isPassword
            Icon={Icons.Lock}
            type="password"
            value={values.password}
            error={touched.password && errors.password ? errors.password : ""}
            onChange={handleChange("password")}
            customLabelStyle={classNames(styles.labelStyle)}
            customInputStyle={classNames(styles.inputStyle)}
          />
          <CustomInput
            label="Confirm Password "
            placeholder="***************"
            required
            isPassword
            Icon={Icons.Lock}
            type="password"
            value={values.confirmPassword}
            error={
              touched.confirmPassword && errors.confirmPassword
                ? errors.confirmPassword
                : ""
            }
            onChange={handleChange("confirmPassword")}
            customLabelStyle={classNames(styles.labelStyle)}
            customInputStyle={classNames(styles.inputStyle)}
          />
        </div>
        <CustomButton
          title="Save Changes"
          containerStyle={classNames("mt-4 ms-auto")}
          onClick={() => {
            handleSubmit();
          }}
          loading={isSubmitting}
          disabled={isSubmitting}
        />
      </form>
    </div>
  );
};

export default Account;
